import React from "react";
import { Outlet } from "react-router-dom";
import { Row } from "reactstrap";
import Header from "./Header";

const AuthLayout = (props) => {
  return (
    <>
      <Header nav={false} />
      <Outlet />
    </>
  );
};

export default AuthLayout;
